module.exports = __webpack_public_path__ + "static/media/trip-6.a2d26b02.png";